import {
  AccordionSummary,
  Box,
  CircularProgress,
  Grid,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import messages from 'components/Refunds/messages';
import { StyledCaption, StyledShortBody } from 'components/Refunds/styles';
import StatusChip from 'components/StatusChip';
import { ShortBody } from 'components/Typography';
import { SINISTER_DOCUMENT_TYPES } from 'constants/globalConstants';
import { StyledAccordionDetails } from 'containers/AmcDetailsPage/MyRefundsTab/Refunds/styles';
import { translate } from 'helpers/intl';
import { get } from 'lodash';
import React from 'react';
import { injectIntl, IntlShape, useIntl } from 'react-intl';
import labels from 'utils/labels';
import { AssuranceIcon } from 'images';
import { DocumentParams, RefundDetails } from '.';
import ClaimButton from './ClaimButton';

interface AgreementClaimType {
  intl: IntlShape;
  refund: {
    statusApplication: String;
    maladyDeclarationSuffix: String;
    numeroPolicy: string;
    numeroApplication: Number;
    beneficiary: String;
    dateNum: Number;
    years: Number;
    dateOccu: string;
  };
  refundDetails: RefundDetails;
  isLoading: boolean;
  expanded: boolean | String;
  index: string;
  onDownloadClick: (
    refundDetails: RefundDetails,
    { type, numeroPolicy }: DocumentParams,
  ) => void;
  loading: boolean;
  downloadError: string;
}

const AgreementClaim = ({
  refund,
  refundDetails,
  isLoading,
  expanded,
  index,
  loading,
  onDownloadClick,
  downloadError,
  ...props
}: AgreementClaimType) => {
  const { formatMessage } = useIntl();
  return (
    <>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Box width="100%">
          <Grid container justify="space-between">
            <Grid item xs={12} sm={3}>
              <Grid item>
                <StyledCaption>
                  {translate(get(messages, 'folderNumber'), props)}
                </StyledCaption>
              </Grid>
              <Grid item>
                <Box marginBottom={0}>
                  <StyledShortBody>
                    {refund.numeroApplication +
                      '' +
                      refund.maladyDeclarationSuffix}
                  </StyledShortBody>
                </Box>
              </Grid>
            </Grid>
            <Grid item xs={6} sm>
              <Grid container direction="column">
                <Grid item>
                  <StyledCaption>
                    {translate(get(messages, 'Beneficiary'), props)}
                  </StyledCaption>
                </Grid>
                <Grid item>
                  <ShortBody>{refund.beneficiary}</ShortBody>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} sm>
              <Grid container direction="column">
                <Grid item>
                  <StyledCaption>
                    {translate(get(messages, 'status'), props)}
                  </StyledCaption>
                </Grid>
                <Grid item>
                  <Box marginBottom={0}>
                    <StatusChip
                      status={'success'}
                      label={translate(get(messages, 'statusAgrement'), props)}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </AccordionSummary>

      {expanded &&
        index === expanded &&
        (isLoading ? (
          <Grid
            container
            justify="center"
            style={{ marginTop: 40, marginBottom: 40 }}
          >
            <CircularProgress color="inherit" size={20} />
          </Grid>
        ) : (
          <StyledAccordionDetails>
            <Box width="100%">
              <Grid container justify="space-between">
                <Grid item xs={6} sm>
                  <Grid container direction="column">
                    <Grid item>
                      <StyledCaption>
                        {translate(get(messages, 'lossDate'), props)}
                      </StyledCaption>
                    </Grid>
                    <Grid item>
                      <ShortBody>{refund.dateOccu}</ShortBody>
                    </Grid>
                  </Grid>
                </Grid>
                {/* <Grid item xs={6} sm>
                  <Grid container direction="column">
                    <Grid item>
                      <StyledCaption>
                        {translate(get(messages, 'claimNumber'), props)}
                      </StyledCaption>
                    </Grid>
                    <Grid item>
                      <Grid item>
                        <ShortBody>{refundDetails.numSinistre}</ShortBody>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid> */}
                <Grid item xs={6} sm>
                  <Grid container direction="column">
                    <Grid item>
                      <StyledCaption>
                        {translate(get(messages, 'costs'), props)}
                      </StyledCaption>
                    </Grid>
                    <Grid item>
                      <ShortBody>
                        {refundDetails.fraisEngagement + ' DH'}
                      </ShortBody>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm></Grid>
                <Grid item xs={6} sm></Grid>
              </Grid>
              <Grid container justify="space-between">
                <ClaimButton
                  onClick={() => {
                    onDownloadClick(refundDetails, {
                      type: SINISTER_DOCUMENT_TYPES.ACCORD,
                      numeroPolicy: refund.numeroPolicy,
                    });
                  }}
                  title={formatMessage(messages.downloadFileTitle)}
                  loading={loading}
                  buttonTitle={labels.downloadAgreementDocument}
                  icon={
                    <img
                      alt="downloadIcon"
                      src={AssuranceIcon['downloadIcon']}
                    />
                  }
                />
                <Grid item xs={6} sm></Grid>
                <Grid item xs={6} sm></Grid>
              </Grid>
              {downloadError && (
                <ShortBody color="red">{downloadError}</ShortBody>
              )}
            </Box>
          </StyledAccordionDetails>
        ))}
    </>
  );
};

export default injectIntl(AgreementClaim);
